import { z } from "zod";

export const ListUserHistoryInputSchema = z.object({
	userId: z.coerce.number().int().positive(),
	page: z.coerce.number().int().min(1).default(1),
	pageSize: z.coerce.number().int().min(1).max(100).default(50),
});

export type ListUserHistoryInputType = z.infer<
	typeof ListUserHistoryInputSchema
>;
